import type { Dictionary, Locale } from "@/shared/i18n";

export function loadDictionary(locale: Locale): Promise<Dictionary> {
  const cached = dictionaries.get(locale);
  if (cached) return cached;
  const loading = importDictionary(locale).catch((error: unknown) => {
    dictionaries.delete(locale);
    throw error;
  });
  dictionaries.set(locale, loading);
  return loading;
}

function importDictionary(locale: Locale): Promise<Dictionary> {
  return locale === "en"
    ? import("@/shared/i18n/en").then(({ en }) => en)
    : import("@/shared/i18n/sv").then(({ sv }) => sv);
}

const dictionaries = new Map<Locale, Promise<Dictionary>>();
